import React from "react";

const recipeImg =(props)=>{
    return (
        <img className="card-img-top" src={props.image}
        alt="dish image"/>
    )
}

export default recipeImg;

// "https://media.blueapron.com/recipes/24547/square_newsletter_images/1593722238-33-0059-9945/0107_2PV2-Veg-Pitas_009_Crop_square_hi_res.jpg?quality=80&width=600"